import { render, staticRenderFns } from "./select-tag.vue?vue&type=template&id=113e199d&scoped=true&"
import script from "./select-tag.vue?vue&type=script&lang=js&"
export * from "./select-tag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113e199d",
  null
  
)

export default component.exports